import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import * as JsSIP from 'jssip';
import { SIP_PROXIES, SIP_PROXIES_FROM_PROVISIONING } from 'flow/actions/phone-actions';
import { b64EncodeUnicode } from 'flow/utils/meeting-utils';
import { MeetingLogLevel, addMeetingLog } from 'flow/utils/meeting-utils';
import { setActiveMeetingCallIdAction, setActiveMeetingCallSessionAction, setActiveMeetingCallUserAgentAction, setMicInUseAction } from 'flow/actions/meeting-actions';
import { selectActiveMeetingAudioReference, selectActiveMeetingCallSession, selectActiveMeetingCallUserAgent, selectActiveMeetingCode, selectActiveMeetingNumber, selectLobbyNumber, selectIsUserLoggedIn, selectSenderName, selectShouldUseExistingUserAgent, selectLobbyMicDeviceInUse } from 'flow/selectors/meeting-selectors';
import { getOwnCountryCodeOrNull } from 'flow/selectors/selectors';
import { getCountryCodeFromNumber } from 'flow/utils/call-utils';
import { parseUrlParameter } from 'flow/utils/browser-utils';
import { resolveMeetingSip, toSupportedMeetingRegion } from 'flow/utils/meeting-sip-region';

/**
 * Resolve the *conference's* region country code for meeting SIP selection, best conference-region
 * signal first:
 *   1. the invite-link `countryCode` param — the host's region, and the only reliable signal for
 *      guests (the external conference endpoint returns no number — see ConferenceDTOFactory).
 *   2. the conference number's country — works for in-app joins; null for guests.
 *   3. the joiner's own country — last resort; null for guests so it can't misroute them, and it
 *      matches the joiner's own SIP region for logged-in in-app joins (the same source the Joining
 *      Info modal uses). resolveMeetingSip applies the IS_UAE_HOST override and the Sweden default.
 */
export var resolveMeetingCountryCode = function resolveMeetingCountryCode(state) {
  var number = selectActiveMeetingNumber(state) || selectLobbyNumber(state);
  var parsedCountryCode = parseUrlParameter('countryCode');
  return toSupportedMeetingRegion(parsedCountryCode) || number && getCountryCodeFromNumber(number) || getOwnCountryCodeOrNull(state);
};
export var getUserAgent = function getUserAgent() {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var state, userAgent, shouldUseExistingUserAgent, phoneReducer, _t, _t2;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            state = getState();
            /**
             * Select the right UserAgent to start the call with
             *
             * isUserLoggedIn = false       -> use the meeting userAgent
             * isUserLoggedIn = true
             *      & to use own SIP user   -> use phone.get('userAgent')
             *      & not own SIP user      -> use the meeting userAgent
             */
            shouldUseExistingUserAgent = selectShouldUseExistingUserAgent(state);
            dispatch(addMeetingLog("MeetingCallClient#getUserAgent should use an existing user agent: ".concat(shouldUseExistingUserAgent)));
            if (!shouldUseExistingUserAgent) {
              _context.next = 5;
              break;
            }
            phoneReducer = state.phone;
            userAgent = phoneReducer && phoneReducer.get('userAgent');
            if (userAgent) {
              _context.next = 4;
              break;
            }
            _context.prev = 1;
            _context.next = 2;
            return dispatch(createMeetingUserAgent());
          case 2:
            userAgent = _context.sent;
            _context.next = 4;
            break;
          case 3:
            _context.prev = 3;
            _t = _context["catch"](1);
            dispatch(addMeetingLog("MeetingCallClient#getUserAgent could not create a userAgent, ".concat(_t)));
          case 4:
            _context.next = 8;
            break;
          case 5:
            _context.prev = 5;
            _context.next = 6;
            return dispatch(createMeetingUserAgent());
          case 6:
            userAgent = _context.sent;
            _context.next = 8;
            break;
          case 7:
            _context.prev = 7;
            _t2 = _context["catch"](5);
            dispatch(addMeetingLog("MeetingCallClient#getUserAgent could not create a userAgent, ".concat(_t2)));
          case 8:
            return _context.abrupt("return", userAgent);
          case 9:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 3], [5, 7]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
var createMeetingUserAgent = function createMeetingUserAgent() {
  return function (dispatch, getState) {
    return new Promise(function (resolve, reject) {
      var state = getState();
      var countryCode = resolveMeetingCountryCode(state);
      var _resolveMeetingSip = resolveMeetingSip(countryCode),
        uri = _resolveMeetingSip.uri,
        password = _resolveMeetingSip.password,
        proxies = _resolveMeetingSip.proxies;
      var finalProxies = selectIsUserLoggedIn(state) && SIP_PROXIES_FROM_PROVISIONING ? SIP_PROXIES : proxies;
      dispatch(addMeetingLog('MeetingCallClient#createMeetingUserAgent create a new user agent'));
      var sockets = finalProxies.map(function (proxy) {
        return {
          socket: new JsSIP.WebSocketInterface(proxy.socketUrl),
          weight: proxy.weight
        };
      });
      var configuration = {
        connection_recovery_max_interval: 120,
        password: password,
        register: false,
        session_timers: false,
        sockets: sockets,
        uri: uri,
        user_agent: 'public-meeting-client-tvx-web'
      };
      var timer = setTimeout(function () {
        return reject('Creating a user agent took too long, took more than 5000ms');
      }, 5000);
      var userAgent = new JsSIP.UA(configuration);
      userAgent.on('connected', function () {
        dispatch(setActiveMeetingCallUserAgentAction(userAgent));
        clearTimeout(timer);
        return resolve(userAgent);
      });
      userAgent.on('newRTCSession', function (callData) {
        var session = callData.session;
        var callId = callData.request.getHeader('Call-ID');
        session.data.callId = callId;
        session.data.isMeeting = true;
        dispatch(setActiveMeetingCallIdAction(callId));
      });
      userAgent.on('registrationFailed', function (data) {
        var response = data && data.response || 'No response';
        var cause = data && data.cause || 'No cause';
        return reject("Failed to create useragent registration failed. Response: '".concat(response, "', cause: '").concat(cause, "'"));
      });
      userAgent.on('disconnected', function (data) {
        var code = data && data.code || 'No code';
        var reason = data && data.reason || 'No reason';
        var error = data && data.error || 'Not an error';
        return reject("Failed to create useragent disconnected. Code: '".concat(code, "', reason: '").concat(reason, "', error: '").concat(error, "'"));
      });

      // TODO: #video Make a general stopper instead for call + video?
      // pagehide is not fully supported in Firefox
      window.addEventListener('beforeunload', function () {
        return userAgent.stop();
      });
      userAgent.start();
    });
  };
};
export var startCall = function startCall(userAgent) {
  return function (dispatch, getState) {
    // eslint-disable-next-line consistent-return
    return new Promise(function (resolve, reject) {
      var state = getState();
      var meetingCode = selectActiveMeetingCode(state);
      if (!meetingCode) {
        return reject('No meetingCode');
      }
      if (!userAgent) {
        return reject('No userAgent');
      }
      var senderName = selectSenderName(state);
      var micDevice = selectLobbyMicDeviceInUse(state);
      dispatch(setMicInUseAction(micDevice));
      var audioReference = selectActiveMeetingAudioReference(state);
      var mediaConstraints = {
        // noiseSuppression pinned on (not left to browser defaults) so the
        // sent track — which own-user speaking detection analyses — has a
        // consistent, denoised input across browsers.
        audio: _objectSpread(_objectSpread({}, micDevice !== null && micDevice !== void 0 && micDevice.deviceId ? {
          deviceId: micDevice.deviceId
        } : {}), {}, {
          noiseSuppression: true
        }),
        video: false
      };
      dispatch(addMeetingLog("MeetingCallClient#startCall will start a call, meetingCode: ".concat(meetingCode, ", \n        senderName: ").concat(senderName, ", micDeviceId: ").concat(micDevice && micDevice.deviceId)));
      var eventHandlers = {
        progress: function progress(data) {
          if (data.originator === 'remote') {
            data.response.body = null;
          }
        },
        failed: function failed(data) {
          dispatch(addMeetingLog("MeetingCallClient#eventHandlers failed to start a call \u2014 originator: ".concat(data === null || data === void 0 ? void 0 : data.originator, ", cause: ").concat(data === null || data === void 0 ? void 0 : data.cause), MeetingLogLevel.ERROR));
          return reject('Start call failed');
        },
        confirmed: function confirmed() {
          dispatch(addMeetingLog('MeetingCallClient#eventHandlers successfully started a call'));
          var oldCallSession = selectActiveMeetingCallSession(state);
          if (oldCallSession) {
            dispatch(addMeetingLog('MeetingCallClient#eventHandlers found an existing call session when setting up new call, will end that session.', MeetingLogLevel.WARN));
            try {
              oldCallSession.terminate();
            } catch (e) {
              dispatch(addMeetingLog("MeetingCallClient#eventHandlers Could not terminate call after setting up new call, ".concat(e && e.message)));
            }
          }
          dispatch(setActiveMeetingCallSessionAction(session));
          return resolve(session);
        },
        ended: function ended(data) {
          dispatch(addMeetingLog("MeetingCallClient#eventHandlers call ended \u2014 originator: ".concat(data === null || data === void 0 ? void 0 : data.originator, ", cause: ").concat(data === null || data === void 0 ? void 0 : data.cause), MeetingLogLevel.WARNING));
        },
        peerconnection: function peerconnection(data) {
          var peerConnection = data && data.peerconnection;
          peerConnection.onaddstream = function (e) {
            var meetingStream = e && e.stream;
            if (audioReference) {
              audioReference.srcObject = meetingStream;
            }
          };
        }
      };
      var options = {
        eventHandlers: eventHandlers,
        mediaConstraints: mediaConstraints,
        extraHeaders: ["X-TVX-CONFERENCE-MEETING-CODE: ".concat(meetingCode), "X-TVX-CONFERENCE-DISPLAY-NAME: ".concat(b64EncodeUnicode(senderName)), "X_TVX_CONFERENCE_MEMBER_UUID: ".concat(senderName.slice(0, 36)), "X-TVX-IS-VIDEO-MEETING-CALL: ".concat(true)]
      };
      var _resolveMeetingSip2 = resolveMeetingSip(resolveMeetingCountryCode(state)),
        dialUri = _resolveMeetingSip2.dialUri;
      var session = userAgent.call(dialUri, options);
    });
  };
};
export var endCall = function endCall() {
  return function (dispatch, getState) {
    dispatch(addMeetingLog('MeetingCallClient#endCall will end call'));
    return new Promise(function (resolve, reject) {
      var state = getState();
      var meetingUserAgent = selectActiveMeetingCallUserAgent(state);
      if (meetingUserAgent) {
        dispatch(addMeetingLog('MeetingCallClient#endCall stopping the user agent'));
        // Shut down the UserAgent
        meetingUserAgent.stop();
      } else {
        // Just stop the call, don't mess with the softphone UserAgent
        dispatch(addMeetingLog('MeetingCallClient#endCall stopping call session since we are using the softphone user agent'));
        var callSession = selectActiveMeetingCallSession(state);
        if (callSession) {
          try {
            callSession.terminate();
          } catch (e) {
            dispatch(addMeetingLog("MeetingCallClient#endCall Could not terminate call, ".concat(e && e.message)));
            return reject(e);
          }
        }
      }
      return resolve();
    });
  };
};